export default __webpack_public_path__ + "static/media/ViperMobile.e5172a50.png";